<template>
	<el-card>
		<div slot="header" class="header">
			<img src="../image/schedule_new.png" class="header-icon">
			<span class="header-title head-title-col">Schedule</span>
		</div>
		<ScheduleForm :patient="patient" v-if="getUserType !== 'observer'"></ScheduleForm>
		<ScheduleTable :patient="patient"></ScheduleTable>
	</el-card>
</template>

<script>
import { mapGetters } from 'vuex'
import OverviewCard from '..'
import ScheduleForm from './Form'
import ScheduleTable from './Table'

export default {
	name: 'patient-schedule-card',
	extends: OverviewCard,

	computed: {
		...mapGetters(['getUserType'])
	},

	components: {
		ScheduleForm,
		ScheduleTable
	}
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
.head-title-col {
	color: #2d3e4f !important;
}
</style>
